/*
    Copyright (C) 2023 - LMS2MTX - Southwest Airlines
*/
export async function login(token) {
  try {
    const url = process.env.REACT_APP_API_URL + "/auth/login";
    const requestHeader = {
      ACCESS_TOKEN: token,
    };
    const request = {
      method: "POST",
      headers: requestHeader,
    };
    const response = await fetch(url, request);
    const json = await response.json();
    if (json.statusCode !== 200) {
      throw new Error("STATUS: " + json.statusCode);
    }
    return json;
  } catch (error) {
    return {
      statusCode: 500,
      body: {
        message: error.message,
      },
    };
  }
}
